<template>
  <div class="prescriptionDetails">
    <el-page-header @back="goBack" content="处方详情"></el-page-header>
    <div class="prescriptionDetails_content">
      <!-- 一级药师拒绝原因字段显示 -->
      <el-card
        class="status_card"
        v-if="userInfo.status === 3 || userInfo.status === 4"
      >
        <div>
          <el-tag
            type="danger"
            class="prescription_type"
            effect="dark"
            size="medium"
            disable-transitions
            ><span class="prescription_status">{{
              userInfo.status_dictText
            }}</span></el-tag
          >

          <div class="prescription_reason">
            原因：{{ userInfo.prescriptionCause }}
          </div>
        </div>
      </el-card>
      <!-- 二级药师拒绝原因字段显示 -->
      <el-card
        class="status_card"
        v-if="userInfo.status === 7 || userInfo.status === 8"
      >
        <div>
          <el-tag
            type="danger"
            class="prescription_type"
            effect="dark"
            size="medium"
            disable-transitions
            ><span class="prescription_status">{{
              userInfo.status_dictText
            }}</span></el-tag
          >

          <div class="prescription_reason">原因：{{ userInfo.drugsCause }}</div>
        </div>
      </el-card>

      <caseDetail
        :case_id="case_id"
        :userInfo="userInfo"
        :imgList="imgList"
      ></caseDetail>
      <div class="prescription-html">
        <span v-html="prescriptionHtml"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { caseQueryById, getPrescriptionForm } from "@/api";
import emptyData from "@/components/common/emptyData.vue";
import caseDetail from "@/components/case/detail";

export default {
  name: "",
  components: { emptyData, caseDetail },
  props: {},
  data() {
    return {
      imgList: [], // 处理加密的图片
      userInfo: {},
      id: this.$route.query.id,
      case_id: this.$route.query.case_id,
      prescriptionHtml: "",
    };
  },
  mounted() {
    this.getPrescription();
    this.getUserInfo();
  },
  methods: {
    goBack() {
      const that = this;
      // that.$router.go(-1); //返回上一层
      that.$router.push({
        path: "/index/user/prescription",
      });
    },

    //获取病例详情
    async getUserInfo() {
      const params = {
        orderNo: this.$route.query.orderNo,
      };
      const res = await caseQueryById(params);
      if (res.code == 1) {
        this.userInfo = res.data;

        // 附件
        let casesSymptom = this.userInfo.cases.symptom;
        if (casesSymptom)
          this.imgList =
            casesSymptom.indexOf(",") != -1
              ? casesSymptom.split(",")
              : [casesSymptom];
        // this.imgList = this.imgList.filter((val)=>{
        //   return process.env.VUE_APP_BASE_API + val;
        // })
      }
    },

    /**
     * 获取处方单html
     */
    async getPrescription() {
      const params = {
        recipeId: this.$route.query.id,
      };

      const res = await getPrescriptionForm(params);
      if (res.code == 1) {
        this.prescriptionHtml = res.data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.prescriptionDetails {
  width: 100%;
  padding: 20px;
  .status_card {
    float: right;
    z-index: 100;
    display: block;
    text-align: center;
    vertical-align: middle;
    position: fixed;
    .prescription_type {
      display: inline-block;
      word-break: break-all;
      width: 100%;
    }
    .prescription_reason {
      word-break: break-all;
      text-align: left;
      padding: 8px;
      font-size: 14px;
      line-height: 16px;
    }
  }
  .prescription-html {
    margin-top: 10px;
  }
}
</style>
